<div class="autocomplete-search" (clickOutside)="hideResults()" (keyup.escape)="hideResults()">
  <div class="search">
    <div class="form-group">
      <label for="{{ 'autocomplete-' + namespace }}">{{ label }}</label>
      <input
        #searchinput
        id="{{ 'autocomplete-' + namespace }}"
        type="text"
        class="search form-control"
        [(ngModel)]="search"
        [ngClass]="{ 'has-results': searchResultsAreVisible }"
        [required]="required"
        [placeholder]="placeholder"
        (keyup)="handleSearch($event)"
        (keyup.arrowup)="handleTraverseUp()"
        (keyup.arrowdown)="handleTraverseDown()"
        (keyup.enter)="handleSelect()"
        (click)="showResults()" />
      <button type="button" (click)="showResults()">
        <i class="fal fa-search"></i>
      </button>
    </div>
    <div *ngIf="searchResultsAreVisible" class="results" (click)="focusSearchInput()">
      <div
        *ngFor="let row of searchResults; let currentIndex = index"
        class="{{ 'result ' + namespace }}"
        [ngClass]="{ 'is-active': currentIndex == activeIndex, 'is-disabled': row.selected }"
        (click)="handleSelect(currentIndex)">
        <span>{{ row[property] }} {{ extraProperty ? '- ' + row[extraProperty] : '' }}</span>
      </div>
      <div class="no-results" *ngIf="searchPagination.currentPage < searchPagination.totalPages">
        <a class="link" href="#" (click)="fetchNext(searchPagination.nextPage, $event)">Load More</a>
      </div>
    </div>
  </div>
</div>
